import fetchUrl from 'utils/fetch';

export function updatePostpone(id, date) {
  return fetchUrl(`/campaign/${id}/postpone?date=${date}`, {
    method: 'PUT',
  });
}



// WEBPACK FOOTER //
// ./src/modules/campaign/api/index.js